import { gql } from '@apollo/client';
import type { DocumentNode, FieldNode, FragmentSpreadNode } from 'graphql';
import { Kind, visit } from 'graphql';

import { LINE_ITEM_HEALTH_COLUMNS, LINE_ITEM_TRAFFICKING_COLUMNS } from '../fragments';

export const GET_LINEITEMS_BY_CAMPAIGNID_LIST = gql`
  query GET_LINEITEMS_BY_CAMPAIGNID_LIST(
    $filterOptions: LineItemFilterOptionsV5
    $sort: LineItemSortOptionV5
    $order: OrderOption
    $limit: Int
    $offset: Int
  ) {
    lineItems: lineItemsV5(
      filterOptions: $filterOptions
      sortOptions: { sort: $sort, order: $order }
      paginationOptions: { limit: $limit, offset: $offset }
    ) {
      edges {
        node {
          ...lineItemTraffickingColumns
        }
      }
      total
    }
    getCurrencyPrecisions {
      code
      decimals
    }
  }
  ${LINE_ITEM_TRAFFICKING_COLUMNS}
`;

const healthColumnsSpread: FragmentSpreadNode = {
  kind: Kind.FRAGMENT_SPREAD,
  name: { kind: Kind.NAME, value: 'lineItemHealthColumns' },
};

function withHealthColumns(document: DocumentNode, operationName: string): DocumentNode {
  const derived = visit(document, {
    OperationDefinition: (node) => ({ ...node, name: { kind: Kind.NAME, value: operationName } }),
    Field: (node): FieldNode | undefined =>
      node.name.value === 'node' && node.selectionSet
        ? {
            ...node,
            selectionSet: { ...node.selectionSet, selections: [...node.selectionSet.selections, healthColumnsSpread] },
          }
        : undefined,
  });

  return { kind: Kind.DOCUMENT, definitions: [...derived.definitions, ...LINE_ITEM_HEALTH_COLUMNS.definitions] };
}

export const GET_LINEITEMS_BY_CAMPAIGNID_LIST_WITH_HEALTH = withHealthColumns(
  GET_LINEITEMS_BY_CAMPAIGNID_LIST,
  'GET_LINEITEMS_BY_CAMPAIGNID_LIST_WITH_HEALTH'
);
